import React, { useState, useRef, useEffect } from "react";
import styles from "./blood_pressure_date_time.module.css";
import ElementTitle from "ui/crfs/element_title";
import DividerLine from "ui/crfs/divider_line";
import DateTimeUI from "../date_time/components/date_time_ui";
import BloodPressureUI from "../blood_pressure/components/blood_pressure_ui";
import DataCompleteChangeModal from "ui/crfs/data_complete_change_modal";
import EntryRuleOverrideModal from "ui/crfs/entry_rule_override_modal";
import RadioGroupUI from "ui/crfs/radio_group/components/radio_group_ui";
import { cloneDeep } from "lodash";
import ElementMenu from "ui/crfs/element_menu";
import LoadingButton from "@mui/lab/LoadingButton";
import moment from "moment";

let tempStorage = null;

export default function BloodPressureDateTime(props) {
  const { field, title, onUpdate, enableQuery, first_randomized_on } = props;

  const [localVal, setLocalVal] = useState((field && field.value_obj) || {});
  const [showingCompleteChangeModal, setShowingCompleteChangeModal] = useState(false);
  const [showingEntryOverrideModal, setShowingEntryOverrideModal] = useState(false);
  const [dataChange, setDataChange] = useState(false);
  const [dataChangeTime, setDataChangeTime] = useState(false);

  useEffect(() => {
    tempStorage = { ...field.value_obj };
    let obj = { ...field.value_obj };
    obj.value_name = field.value_name || "";
    obj.value2_name = field.value2_name || "";
    obj.value3_name = field.value3_name || "";
    obj.value4_name = field.value4_name || "";
    obj.value5_name = field.value5_name || "";
    setLocalVal(obj);
  }, [field.value_obj]);

  const systolic_position = "value";
  const diastolic_position = "value2";
  const date_position = "value3";
  const time_position = "value4";
  const not_done_position = "value5";

  const commonUpdateAction = (value, reason = null) => {
    if (reason) {
      onUpdate({ ...value, reason });
    } else {
      onUpdate(value);
    }

    tempStorage = value;
  };

  const acceptTempStorage = (reason) => {
    commonUpdateAction(localVal, reason);
    tempStorage = localVal;
    setShowingCompleteChangeModal(false);
    setShowingEntryOverrideModal(false);
    setDataChange(false);
  };

  const onChange = (key, value) => {
    //tempStorage is shared, so set to the value we want to referencer
    if (!dataChange) {
      tempStorage = localVal;
    }
    let obj = cloneDeep(localVal);
    if (key === "blood_pressure") {
      obj[systolic_position] = value[systolic_position];
      obj[diastolic_position] = value[diastolic_position];
    }
    setLocalVal(obj);
    setDataChange(true);
  };

  const updateValue = (key, value, error_override = false) => {
    let obj = cloneDeep(localVal);
    if (key === "datetime") {
      if (date_entry_rule_error(value)) {
        // setLocalVal(tempStorage);
        obj[date_position] = value[date_position];
        obj[time_position] = value[time_position];
        setLocalVal(obj);
        setDataChangeTime(true);
      } else {
        obj[date_position] = value[date_position];
        obj[time_position] = value[time_position];
        setLocalVal(obj);
        commonUpdateAction(obj);
        setDataChange(true);
      }
      // date_entry_rule_error();
    }
    if (key === "blood_pressure") {
      if (entry_rule_error()) {
        if (field.entry_rule_override && !error_override) {
          setShowingEntryOverrideModal(true);
        } else if (error_override) {
          obj[systolic_position] = value[systolic_position];
          obj[diastolic_position] = value[diastolic_position];
          setLocalVal(obj);
          commonUpdateAction(obj);
          setDataChange(false);
        } else {
          setLocalVal(tempStorage);
          setDataChange(false);
        }
        return;
      } else {
        commonUpdateAction(localVal);
      }
    }
    if (key === "not_done") {
      obj[not_done_position] = value[not_done_position];
      setLocalVal(obj);
      commonUpdateAction(obj);
    }
  };

  const closeModal = () => {
    setShowingCompleteChangeModal(false);
    setShowingEntryOverrideModal(false);
    setLocalVal(tempStorage);
    setDataChange(false);
  };

  const entry_rule_error = () => {
    let error = false;
    if ((localVal.value || localVal.value2) && field.entry_rules && dataChange) {
      field.entry_rules.some((rule) => {
        if (rule.rule_type === "min") {
          if (parseInt(localVal.value) < parseInt(rule.value) || parseInt(localVal.value2) < parseInt(rule.value)) {
            error = `Must be greater than or equal to ${rule.value}`;
            return error;
          }
        } else if (rule.rule_type === "max") {
          if (parseInt(localVal.value) > parseInt(rule.value) || parseInt(localVal.value2) > parseInt(rule.value)) {
            error = `Must be less than or equal to ${rule.value}`;
            return error;
          }
        }
      });
    }
    return error;
  };

  const date_entry_rule_error = (value) => {
    let _value = value?.value3 || localVal.value3;
    let _value2 = value?.value4 || localVal.value4;
    let error = false;
    if (_value && _value2 && field.entry_rules && ((_value && _value2) || dataChangeTime)) {
      field.entry_rules.some((rule) => {
        if (rule.rule_type === "after_randomization" && first_randomized_on) {
          if (
            moment(`${_value} ${_value2}`, "YYYY-MM-DD HH:mm").diff(
              moment(moment.utc(first_randomized_on)).tz(moment.tz.guess()),
              "minutes"
            ) < 0
          ) {
            error = `Must be greater than or equal to ${moment.utc(first_randomized_on).tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm")}`;
            return error;
          }
        }
      });
    }
    return error;
  };

  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.input_flex}>
        <div className={styles.left_split}>
          {enableQuery ? (
            <div>
              <ElementTitle required={field.required} title={title} />
            </div>
          ) : (
            <div>{title}</div>
          )}
        </div>
        <div className={styles["right-split"]}>
          <div className={styles.flex_column}>
            <div className={styles.flex_row}>
              <BloodPressureUI
                {...props}
                onChange={(value_obj) => {
                  onChange("blood_pressure", value_obj);
                }}
                onUpdate={() => {
                  updateValue("blood_pressure", null);
                }}
                field={{ ...field, value_obj: localVal }}
                systolic_position={systolic_position}
                diastolic_position={diastolic_position}
                error={dataChangeTime && entry_rule_error()}
              />
              <div>
                <div className={styles.flex_row}>
                  <DateTimeUI
                    key={field.id}
                    {...props}
                    field={{ ...field, value_obj: localVal }}
                    onUpdate={(value_obj) => {
                      updateValue("datetime", value_obj);
                    }}
                    date_position={date_position}
                    time_position={time_position}
                  />
                </div>
                <div className={styles.flex_row}></div>
                {dataChangeTime && date_entry_rule_error().constructor === String ? (
                  <div className={styles.input_flex}>
                    <div className={styles.error}>{date_entry_rule_error()}</div>
                    {field?.entry_rule_override ? (
                      <LoadingButton
                        variant="outlined"
                        loading={false}
                        onClick={() => updateValue()}
                        sx={{
                          fontSize: 14,
                          padding: "2px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "10px",
                        }}
                      >
                        Save Anyway
                      </LoadingButton>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.flex_row}>
              <RadioGroupUI
                {...props}
                onUpdate={(value_obj) => updateValue("not_done", value_obj)}
                field={{ ...field, value_obj: localVal }}
                options={[{ label: "Not Done", value: "not_done" }]}
                value_position={"value5"}
                value_name_position={"value5_name"}
              />
              <div className={styles.audit_icon}>
                <ElementMenu {...props} />
              </div>
            </div>
            <div className={styles.flex_row}>
              {entry_rule_error().constructor === String ? (
                <div className={styles.input_flex}>
                  <div className={styles.error}>{entry_rule_error()}</div>
                  {field.entry_rule_override ? (
                    <LoadingButton
                      variant="outlined"
                      loading={false}
                      onClick={() => updateValue(true)}
                      sx={{
                        fontSize: 14,
                        padding: "2px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "10px",
                      }}
                    >
                      Save Anyway
                    </LoadingButton>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <DividerLine />
      <DataCompleteChangeModal isOpen={showingCompleteChangeModal} close={closeModal} onYes={acceptTempStorage} />
      <EntryRuleOverrideModal isOpen={showingEntryOverrideModal} close={closeModal} onYes={acceptTempStorage} />
    </div>
  );
}
